<template>
	<div class="footer3" id="footer">
		<div v-if="!isEnterPrise" class="footer-content">
			<div class="logo">
				<div class="logo-nutstore">
					<img
						border="0"
						src="/static/images/large@2x.png"
						alt="Nutstore"
						class="footerLogo"
					/>
				</div>
				<div class="copyright">
					&copy; {{ getConstants('YEAR') }}
					{{ getConstants('SHANGHAI_YIJING') }}
				</div>
				<br />
				<div class="page-locale-para">
					<span class="locale-item" @click="setPageLocaleCookie('zh_CN')"
						>中文</span
					>
					<span class="locale-item" @click="setPageLocaleCookie('en')"
						>English</span
					>
					<span class="locale-item" @click="setPageLocaleCookie()">{{
						getConstants('AUTO')
					}}</span>
				</div>
			</div>
			<div class="links">
				<div class="link-list">
					<ul>
						<li class="header">{{ getConstants('NUTSTORE') }}</li>
						<li class="link">
							<a href="/s/pricing" target="_blank">{{
								getConstants('INDIVIDUAL_EDITION_FOR_SHORT')
							}}</a>
						</li>
						<li class="link">
							<a href="/s/team" target="_blank">{{
								getConstants('TEAM_EDITION_FOR_SHORT')
							}}</a>
						</li>
						<li class="link">
							<a href="/s/enterprise" target="_blank">{{
								getConstants('ENTERPRISE_EDITION_FOR_SHORT')
							}}</a>
						</li>
						<li class="link">
							<a href="/s/downloads" target="_blank">{{
								getConstants('DOWNLOAD_CLIENTS_FOR_SHORT')
							}}</a>
						</li>
						<li class="link">
							<a
								href="http://help.jianguoyun.com/?page_id=843"
								target="_blank"
								>{{ getConstants('FEATURES') }}</a
							>
						</li>
						<li class="link">
							<a
								href="http://help.jianguoyun.com/?page_id=3961"
								target="_blank"
								>{{ getConstants('PRIVACY_STATEMENT') }}</a
							>
						</li>
					</ul>
				</div>

				<div class="link-list">
					<ul>
						<li class="header">{{ getConstants('RESOURCER_COMMUNITY') }}</li>
						<li class="link">
							<a href="/d/applyTeamFreeTrial" target="_blank">{{
								getConstants('ENTERPRISE_APPLY_TRIAL')
							}}</a>
						</li>
						<li class="link">
							<a href="http://www.jianguoyun.com/s/content/" target="_blank">{{
								getConstants('APP_GALAXY')
							}}</a>
						</li>
						<li class="link">
							<a href="/s/pricing" target="_blank">{{
								getConstants('SERVICE_PRICE')
							}}</a>
						</li>
						<li class="link">
							<a href="http://help.jianguoyun.com/" target="_blank">{{
								getConstants('HELP_CENTER')
							}}</a>
						</li>
						<li class="link">
							<a href="/s/tutorial" target="_blank">{{
								getConstants('VIDEO_TUTORIAL')
							}}</a>
						</li>
						<li class="link">
							<a href="http://blog.jianguoyun.com/" target="_blank">{{
								getConstants('BLOG')
							}}</a>
						</li>
					</ul>
				</div>

				<hot-link></hot-link>

				<div class="link-list">
					<ul>
						<li class="header">{{ getConstants('MANAGEMENT_SUPPORT') }}</li>
						<li class="link">
							<a href="https://www.jianguoyun.com/s/helpdesk" target="_blank">{{
								getConstants('ONLINE_SUPPORT')
							}}</a>
						</li>
						<li class="link">
							<a href="/s/contactus" target="_blank">{{
								getConstants('CONTACT_US')
							}}</a>
						</li>
						<li class="link">
							<a href="/static/html/joinus/index.html" target="_blank">{{
								getConstants('JOIN_US2')
							}}</a>
						</li>
					</ul>
				</div>
			</div>

			<div class="QRcode">
				<p>{{ getConstants('CONTENT_WECHAT') }}</p>
				<img src="/static/images/wechat_barcode.png" alt />
			</div>
		</div>
		<div class="cert">
			<p>
				<span>开发者名称：上海亦净网络科技有限公司</span>
				<span>版本：4.23.1</span>
				<span
					><a
						rel="nofollow"
						target="_blank"
						href="http://help.jianguoyun.com/?page_id=3961"
						>隐私协议</a
					></span
				>
				<span
					><a
						rel="nofollow"
						target="_blank"
						href="https://help.jianguoyun.com/?p=5972"
						>用户权限</a
					></span
				>
			</p>
			<p>
				<span class="iso"
					><a rel="nofollow" target="_blank" href="/static/images/ISO.jpg"
						>ISO27001认证</a
					></span
				>
				<span
					><a
						rel="nofollow"
						target="_blank"
						href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502003377"
						>{{ getConstants('POLICE_RECORD') }}</a
					></span
				>
				<span
					><a rel="nofollow" target="_blank" href="https://beian.miit.gov.cn">{{
						getConstants('ICP_RECORD')
					}}</a></span
				>
				<span>增值电信业务经营许可证：B1-20193672</span>
				<span
					><a rel="nofollow" target="_blank" href="/static/images/IST.jpg"
						>等保三级</a
					></span
				>
			</p>
			<p>
				<span>违法和不良信息举报电话：021-50782360</span>
				<span
					><a rel="nofollow" target="_blank" href="https://www.12377.cn"
						>网上有害信息举报专区</a
					></span
				>
				<span
					><a
						rel="nofollow"
						target="_blank"
						href="http://www.shjbzx.cn/"
						class="shjbzx"
					></a
				></span>
			</p>
		</div>

		<div v-if="isEnterPrise" class="is_enterprise_instance">
			<div style="margin: 0 auto; text-align: center;">
				<span
					style="margin-left: 10px; color: #000; opacity: .5; filter: alpha(opacity=50);"
					@click="setPageLocaleCookie('zh_CN')"
					>中文</span
				>
				<span
					style="margin-left: 10px; color: #000; opacity: .5; filter: alpha(opacity=50);"
					@click="setPageLocaleCookie('en')"
					>English</span
				>
				<span
					style="margin-left: 10px; color: #000; opacity: .5; filter: alpha(opacity=50);"
					@click="setPageLocaleCookie()"
					>{{ getConstants('AUTO') }}</span
				>
			</div>
		</div>
	</div>
</template>
<script>
import HotLink from './HotLink'

export default {
	data() {
		return {
			isEnterPrise: PageInfo.is_enterprise_instance,
		}
	},
	components: {
		HotLink,
	},
	methods: {
		setPageLocaleCookie(value) {
			let toDelete = !value
			let d = new Date()
			if (toDelete) {
				d = new Date('1970-01-01')
			} else {
				d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000)
			}

			let expires = 'expires=' + d.toGMTString()
			value = toDelete ? '' : value
			document.cookie = 'page_locale=' + value + '; ' + expires + '; path=/'
			location.reload()
		},
	},
}
</script>
<style lang="scss">
.footer3 {
	position: relative;
	text-align: left;
	background-color: #fbfbfb;
	border-top: 1px solid #d2d6db;

	.footer-content {
		margin: 0 auto;
		width: 100%;
		max-width: 1100px;
		overflow: hidden;
		padding-top: 40px;
		text-align: center;

		.QRcode,
		.logo,
		.links,
		.language {
			display: inline-block;
			vertical-align: top;
			text-align: left;
		}

		.QRcode {
			p {
				margin: 0 0 18px 0;
				color: #666;
				line-height: 30px;
				font-size: 12px;
			}
			img {
				width: 136px;
			}
		}

		.logo {
			margin-left: 40px;
			text-align: center;

			.logo-nutstore img {
				height: 34px;
				margin-top: 50px;
			}

			.copyright {
				color: #666;
				margin-top: 20px;
			}

			.page-locale-para {
				.locale-item {
					font-size: 14px;
					margin-left: 10px;
					opacity: 0.5;
					filter: opacity(50);
					color: #000;
					cursor: pointer;
				}
			}
		}

		.links {
			margin-left: 40px;

			.link-list {
				width: 120px;
				display: inline-block;
				vertical-align: top;
				font-size: 12px;

				&:first-child {
					margin-left: 0;
				}

				.header {
					display: block;
					margin-bottom: 10px;
					line-height: 30px;
					font-size: 12px;
					color: #666;
				}

				.link {
					line-height: 30px;
					width: 120px;
					a {
						opacity: 0.5;
						filter: opacity(50);
						color: #000;
					}
				}
			}
		}

		.language {
			display: none;

			.locale-item {
				margin-left: 10px;
				opacity: 0.5;
				filter: opacity(50);
				color: #000;
			}
		}

		.ICP {
			margin: 0 auto;
			width: 100%;
			text-align: center;

			a {
				display: inline-block;
				vertical-align: top;
				text-decoration: none;
				color: #939393;
			}
		}
	}

	ul,
	li {
		margin: 0;
		padding: 0;
		list-style: none;
		display: inline-block;
	}

	.reports-links,
	.SEO-links {
		position: absolute;
		left: 0;
		bottom: 160px;
		margin: 0 10%;
		border: 1px solid #d2d6db;
		box-shadow: 0 0 3px 3px #fbfbfb;
		padding: 20px 5%;
		width: 70%;
		background-color: #fff;
		z-index: 100;

		.links-title {
			line-height: 40px;
		}

		.separate-line {
			margin: 10px auto;
			width: 100%;
			border-bottom: 1px solid #d2d6db;
		}

		.links-row {
			margin-top: 5px;

			a {
				display: inline-block;
				margin-right: 30px;
				color: #000;
				line-height: 24px;
				opacity: 0.6;
				filter: opacity(60);
			}
		}
	}

	.reports-links {
		bottom: 310px;
	}
}

.cert {
	text-align: center;
	margin: 10px;
	padding-top: 20px;
	color: #9b9b9b;
	font-size: 12px;
	p {
		margin: 0px;
	}
	span {
		display: inline-block;
		margin: 0 10px;
		height: 30px;
		line-height: 30px;
		vertical-align: middle;

		a {
			color: #9b9b9b;
		}
	}
	.iso {
		padding-left: 30px;
		background: url('/static/images/iso27001.png') no-repeat left center;
	}
}

.is_enterprise_instance {
	width: 940px;
	margin: 0 auto;
	border-top: 1px solid #d2d6db;
	font-size: 14px;
	padding-top: 20px;
	padding-bottom: 20px;
}

@media (max-width: 960px) {
	.footer3 {
		padding-bottom: 30px;

		.footer-content {
			.logo {
				float: none;
				margin: 20px auto 0;
				width: 100%;
			}

			.links,
			.language {
				margin: 0 auto;
				width: 100%;
				text-align: center;
			}

			.links {
				float: none;

				.link-list {
					margin: 25px auto 0;
					width: 100%;

					.header {
						display: block;
					}

					.link {
						margin: 5px;
					}

					&:nth-child(1) {
						ul {
							width: 300px;
							text-align: center;
							position: relative;
							left: -20px;
						}
						li:nth-child(n + 1) {
							margin-left: 30px;
						}
					}
				}
			}

			.QRcode {
				.img,
				img {
					margin: 0 auto;
				}
			}

			.reports-links {
				bottom: 460px;
			}
		}

		.QRcode,
		.footer-content .QRcode {
			margin: 20px auto;
			width: 100%;
			text-align: center;
		}

		.cert {
			span {
				margin: 0;
			}
		}

		.hot-links {
			&:hover {
				.SEO-links {
					display: none;
				}
			}
		}
	}
	.is_enterprise_instance {
		width: 100%;
	}
}

@media (max-width: 1280px) {
	.footer3 {
		.logo .logo-nutstore img.footerLogo {
			height: 30px;
		}
	}
}

.shjbzx {
	width: 80px;
	height: 30px;
	display: inline-block;
	background: url('/static/images/shjbzx.png') no-repeat center center;
	position: relative;

	&:hover {
		background: url('/static/images/shjbzx_hover.png') no-repeat center center;
	}
}
</style>
